module.exports = __webpack_public_path__ + "static/media/invIcon1.a32b405a.png";